// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodNutritionalFormatId } from './FoodNutritionalFormat';
import { foodNutrientTypeId } from './FoodNutrientType';
import { z } from 'zod';
export const foodNutritionalFormatNutrientId = (z.number());
export const foodNutritionalFormatNutrient = z.object({
    id: foodNutritionalFormatNutrientId,
    format_id: foodNutritionalFormatId,
    nutrient_type_id: foodNutrientTypeId,
    parent_id: foodNutritionalFormatNutrientId.nullable(),
    display_name: z.string().nullable(),
    conversion_factor: z.number(),
    display_unit: z.string().nullable(),
    daily_reference: z.number().nullable(),
    display_order: z.number(),
    mandatory: z.boolean(),
});
export const foodNutritionalFormatNutrientInitializer = z.object({
    id: foodNutritionalFormatNutrientId.optional(),
    format_id: foodNutritionalFormatId,
    nutrient_type_id: foodNutrientTypeId,
    parent_id: foodNutritionalFormatNutrientId.optional().nullable(),
    display_name: z.string().optional().nullable(),
    conversion_factor: z.number().optional(),
    display_unit: z.string().optional().nullable(),
    daily_reference: z.number().optional().nullable(),
    display_order: z.number().optional(),
    mandatory: z.boolean().optional(),
});
export const foodNutritionalFormatNutrientMutator = z.object({
    id: foodNutritionalFormatNutrientId.optional(),
    format_id: foodNutritionalFormatId.optional(),
    nutrient_type_id: foodNutrientTypeId.optional(),
    parent_id: foodNutritionalFormatNutrientId.optional().nullable(),
    display_name: z.string().optional().nullable(),
    conversion_factor: z.number().optional(),
    display_unit: z.string().optional().nullable(),
    daily_reference: z.number().optional().nullable(),
    display_order: z.number().optional(),
    mandatory: z.boolean().optional(),
});
//# sourceMappingURL=FoodNutritionalFormatNutrient.js.map